import AppRoutes from "./routes/AppRoutes";
import { useAppAuthGuard } from "./hooks/useAppAuthGuard";
import { useFirebaseMessaging } from "./hooks/useFirebaseMessaging";

function App() {
  useAppAuthGuard();
  useFirebaseMessaging();

  return <AppRoutes />;
}

export default App;
